import Housing from './Housing';

const RealEstate = () => <Housing mode="sale" />;
export default RealEstate;
